<script setup lang="ts">
  import { FormInput } from '@/shared/ui';
  import { getMaskConfig } from '@/shared/lib/mask';
  import OpenTrainingExternalCompanyRow from './OpenTrainingExternalCompanyRow.vue';
  import type { useOpenTrainingExternalCompanyInstructors } from '../../model/useOpenTrainingExternalCompanyInstructors';

  defineProps<{
    form: ReturnType<typeof useOpenTrainingExternalCompanyInstructors>;
  }>();

  const cnpjMask = getMaskConfig('cnpj', undefined, true);
</script>

<template>
  <div class="grid grid-cols-[240px_minmax(300px,1fr)] gap-6 border-b border-gray-02 px-6 py-8">
    <FormInput
      id="open-training-external-company-cnpj"
      :model-value="form.cnpj.value"
      label="CNPJ:"
      label-class="text-sm font-semibold text-gray-07"
      type="text"
      placeholder="00.000.000/0000-00"
      :mask="cnpjMask ?? undefined"
      :error="form.cnpjError.value ?? undefined"
      @update:model-value="form.setCnpj(String($event))"
    />
    <FormInput
      id="open-training-external-company-name"
      :model-value="form.companyName.value"
      label="Razão Social:"
      label-class="text-sm font-semibold text-gray-07"
      type="text"
      placeholder="Razão social do ministrante externo"
      :error="form.companyNameError.value ?? undefined"
      @update:model-value="form.setCompanyName(String($event))"
    />
  </div>

  <OpenTrainingExternalCompanyRow
    v-for="(row, index) in form.rows.value"
    :key="row.id"
    :row="row"
    :is-first="index === 0"
    :is-add-disabled="!form.canAddMore.value"
    @update:name="form.setName(index, $event)"
    @update:training-date="form.setTrainingDate(index, $event)"
    @select-curriculum-file="form.selectCurriculumFile(index, $event)"
    @remove-curriculum-file="form.removeCurriculumFile(index)"
    @add="form.addRow()"
    @remove="form.removeRow(index)"
  />
</template>
